module.exports = __webpack_public_path__ + "img/Screen_Shot_3.1175c058.png";